import { BracketHeading } from "../shared/components/BracketHeading";
import { FlowBracket } from "../shared/components/FlowBracket";
import { BracketProps } from "../shared/types/interfaces";
// import frame from "./frame.png";

const matchIndexPositions: {
  [key: number]: {
    node: {
      x: number;
      y: number;
    };
  };
} = {
  // lower bracket round 1
  0: {
    node: { x: 0, y: 519 },
  },
  1: {
    node: { x: 0, y: 625 },
  },
  2: {
    node: { x: 0, y: 731 },
  },
  3: {
    node: { x: 0, y: 837 },
  },
  4: {
    node: { x: 232, y: 570 },
  },
  5: {
    node: { x: 232, y: 786 },
  },
  6: {
    node: { x: 463, y: 570 },
  },
  7: {
    node: { x: 463, y: 786 },
  },
  8: {
    node: { x: 695, y: 678 },
  },
  9: {
    node: { x: 926, y: 678 },
  },
  10: {
    node: { x: 0, y: 44 },
  },
  11: {
    node: { x: 0, y: 151 },
  },
  12: {
    node: { x: 0, y: 256 },
  },
  13: {
    node: { x: 0, y: 362 },
  },
  14: {
    node: { x: 463, y: 95 },
  },
  15: {
    node: { x: 463, y: 310 },
  },
  16: {
    node: { x: 926, y: 203 },
  },
  17: {
    node: { x: 1127, y: 419 },
  },
};

export const DoubleElim12Skewed = ({ gameId, bracket, pickedResults, onTeamClick }: BracketProps) => {
  if (!bracket.matches) return null;

  return (
    <div className="relative w-full">
      {/* Bracket */}
      <div className="custom-scrollbar relative overflow-x-auto overflow-y-hidden">
        {/* For dev only */}
        {/* <img
          className="absolute"
          src={frame}
          style={{
            top: "0",
            width: "1275px",
            minWidth: "1275px",
          }}
        /> */}

        <div
          style={{
            width: "1275px",
            minWidth: "1275px",
            height: "925px",
            minHeight: "925px",
          }}
        >
          <BracketHeading
            style={{
              width: "1075px",
            }}
          >
            Upper Bracket
          </BracketHeading>
          <BracketHeading
            style={{
              width: "1075px",
              top: "475px",
            }}
          >
            Lower Bracket
          </BracketHeading>
          <FlowBracket
            gameId={gameId}
            circuitName={bracket.circuitName}
            tournamentName={bracket.parentTournamentName}
            matchIndexPositions={matchIndexPositions}
            matches={bracket.matches}
            pickedResults={pickedResults}
            onTeamClick={onTeamClick}
          />
        </div>
      </div>
    </div>
  );
};
